import React from 'react';
import ProductCatalog from '../components/ProductCatalog';

const Catalog = () => {
  return (
    <main style={{ paddingTop: '100px' }}>
      <ProductCatalog />
    </main>
  );
};

export default Catalog;
